import React from "react";

import { DotLoader } from "react-spinners";

const Loader = () => {
  return (
    <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-gray-200 bg-opacity-50">
      <div
        className="relative"
        style={{
          color: "purple",
        }}
      >
        <DotLoader speedMultiplier={2} size={50} />
      </div>
    </div>
  );
};

export default Loader;
